import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-caption text-grey-darken-1" }
const _hoisted_2 = { class: "text-caption text-grey-darken-1" }
const _hoisted_3 = { class: "text-caption text-grey-darken-1" }
const _hoisted_4 = {
  class: "text-caption",
  style: {opacity: .95}
}

import { ref, computed } from 'vue';
import { useDisplay } from 'vuetify';


const __default__ = { name: 'ReportFilterDate' }


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    records: {},
    cols: {}
  },
  setup(__props: any) {

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const props = __props;

function getValue(keys: string[]): number {
  if (!props.records) return 0;
  for (const k of keys) {
    const val = (props.records as any)[k];
    if (val !== undefined && val !== null) {
      if (typeof val === 'string') return Number(val) || 0;
      if (typeof val === 'number') return val;
    }
  }
  return 0;
}
function formatCurrency(value: number | undefined | null) {
  if (value == null) return '$0.00';
  return Number(value).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
}

/* ====== Dark mode ====== */
const isDarkMode = ref(
  typeof window !== 'undefined'
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
    : false
);
if (typeof window !== 'undefined') {
  window.matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', e => (isDarkMode.value = e.matches));
}

/* ====== Branding por hostname ====== */
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isDominiomedios = hostname === 'crm.dominiomedios.com';
const BLUE_BASE = '#2563eb'; // color base para otros clientes

// Helpers HSL
function hexToHsl(hex: string) {
  let r = 0, g = 0, b = 0;
  const c = hex.replace('#','');
  if (c.length === 3) {
    r = parseInt(c[0] + c[0], 16);
    g = parseInt(c[1] + c[1], 16);
    b = parseInt(c[2] + c[2], 16);
  } else {
    r = parseInt(c.substring(0,2), 16);
    g = parseInt(c.substring(2,4), 16);
    b = parseInt(c.substring(4,6), 16);
  }
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r,g,b), min = Math.min(r,g,b);
  let h = 0, s = 0, l = (max + min) / 2;
  const d = max - min;
  if (d !== 0) {
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }
  return { h, s, l };
}
function hslToHex(h: number, s: number, l: number) {
  let r: number, g: number, b: number;
  if (s === 0) {
    r = g = b = l;
  } else {
    const hue2rgb = (p: number, q: number, t: number) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1/6) return p + (q - p) * 6 * t;
      if (t < 1/2) return q;
      if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }
  const toHex = (x: number) => Math.round(x * 255).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
function cardBgFromBase(baseHex: string, dark = false) {
  const { h, s } = hexToHsl(baseHex);
  // fondo para card: muy claro en light, bastante oscuro pero legible en dark
  const l = dark ? 0.16 : 0.93;
  const sAdj = dark ? Math.min(1, s * 0.75) : Math.max(0.25, s * 0.45);
  return hslToHex(h, sAdj, l);
}
function readableTextColor(bgHex: string) {
  // luminancia rápida: si es oscuro => blanco, si es claro => #111
  const c = bgHex.replace('#','');
  const r = parseInt(c.substring(0,2), 16);
  const g = parseInt(c.substring(2,4), 16);
  const b = parseInt(c.substring(4,6), 16);
  const luminance = (0.299*r + 0.587*g + 0.114*b)/255;
  return luminance < 0.5 ? '#fff' : '#111';
}

/* ====== Estilos de tarjeta ====== */
// Cards normales
/*const cardStyle = computed(() => {
  if (isDominiomedios) {
    // Respeta tu #232223 en dark; y #ececec en light
    const bg = isDarkMode.value ? '#232223' : '#ececec';
    const color = isDarkMode.value ? '#fff' : '#111';
    return `background:${bg}; color:${color};`;
  }
  // Otros clientes: derivado de azul
  const bg = cardBgFromBase(BLUE_BASE, isDarkMode.value);
  const color = readableTextColor(bg);
  return `background:${bg}; color:${color};`;
});*/

// Tarjeta de autorización (badge de marca)
const authStyle = computed(() => {
  if (isDominiomedios) {
    return 'background:#801631; color:#fff; text-align:center;';
  }
  // Para otros clientes usa un acento del azul base (un poco más saturado y medio oscuro)
  const { h, s } = hexToHsl(BLUE_BASE);
  const bg = hslToHex(h, Math.min(1, s * 0.85), 0.35);
  return `background:${bg}; color:#fff; text-align:center;`;
});

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "6",
        md: 12/_ctx.cols
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "px-6 py-lg-8 py-3 subiva-card",
            style: _normalizeStyle(_ctx.cardStyle)
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "font-weight-bold mb-2" }, "Subtotal", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(!isMobile.value?'text-h6':'text-h7')
              }, _toDisplayString(formatCurrency(getValue(['sum_subtotal']))), 3),
              _createElementVNode("div", _hoisted_1, " Sugerido: " + _toDisplayString(formatCurrency(getValue(['sum_suggested_subtotal']))), 1)
            ]),
            _: 1,
            __: [0]
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["md"]),
      _createVNode(_component_v_col, {
        cols: "6",
        md: 12/_ctx.cols
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "px-6 py-lg-8 py-3 subiva-card",
            style: _normalizeStyle(_ctx.cardStyle)
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "font-weight-bold mb-2" }, "IVA", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(!isMobile.value?'text-h6':'text-h7')
              }, _toDisplayString(formatCurrency(getValue(['sum_iva']))), 3),
              _createElementVNode("div", _hoisted_2, " Sugerido: " + _toDisplayString(formatCurrency(getValue(['sum_suggested_iva']))), 1)
            ]),
            _: 1,
            __: [1]
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["md"]),
      _createVNode(_component_v_col, {
        cols: "6",
        md: 12/_ctx.cols
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "px-6 py-lg-8 py-3 subiva-card",
            style: _normalizeStyle(_ctx.cardStyle)
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font-weight-bold mb-2" }, "Total", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(!isMobile.value?'text-h6':'text-h7')
              }, _toDisplayString(formatCurrency(getValue(['sum_total']))), 3),
              _createElementVNode("div", _hoisted_3, " Sugerido: " + _toDisplayString(formatCurrency(getValue(['sum_suggested_total']))), 1)
            ]),
            _: 1,
            __: [2]
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["md"]),
      _createVNode(_component_v_col, {
        cols: "6",
        md: 12/_ctx.cols
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "px-6 py-lg-8 py-3 subiva-card",
            style: _normalizeStyle(authStyle.value)
          }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "font-weight-bold mb-2" }, "Necesitan Autorización", -1)),
              _createElementVNode("div", {
                class: _normalizeClass(!isMobile.value?'text-h6':'text-h7')
              }, _toDisplayString(getValue(['total_needs_authorization', 'total_ventas_needs_authorization'])) + "/ " + _toDisplayString(getValue(['total_quotations', 'ventas'])), 3),
              _createElementVNode("div", _hoisted_4, _toDisplayString(formatCurrency(getValue(['sum_needs_authorization']))), 1)
            ]),
            _: 1,
            __: [3]
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["md"])
    ]),
    _: 1
  }))
}
}

})